// Helper for simlifying and standardising handling the feedback of form validation to the client interface.
// Notes:
//  * Validation processing should be handled in the "/common/models/" code - this just handles calling &
//    displaying the result of a validation
//  * DOM changes assume Bootstrap 4 standards for indicating validation
//    See: https://getbootstrap.com/docs/4.0/components/forms/#validation

const $ = App.common.jQuery

const Validator = require('common/helpers/validate')

class FormValidation {
   static init(formid, vmodel, onvalidate) {
      let formdom = $(formid)

      // console.log(formid, vmodel, onvalidate, onvalidate instanceof Function)
      // No model given? Derive one from form data
      if (!onvalidate && (!vmodel || vmodel instanceof Function)) {
         onvalidate = vmodel
         vmodel = undefined
      }
      if (!vmodel) {
         vmodel = FormValidation.htmlFormValidation(formdom)
      }

      // TODO: Per-field focus/blur validation
      formdom.on('submit',function(e) {
         // if (formdom.hasClass('was-validated') && formdom.hasClass('is-valid')) {
// console.log(e.originalEvent.submitter, submit.attr('name'), submit.val())
         if (formdom.hasClass('is-valid')) {
            // Already validated!
            // console.log('Already Validated')
            return;
         }
         e.preventDefault();

         // Handle tracking triggered submit button value
         let submit = $(e.originalEvent?.submitter)
         if (submit.attr('name') && submit.val()) {
            let name = submit.attr('name')
            let svf = formdom.find(`[name="${name}"][type="hidden"]`)
            // Add a hidden field for submit value if needed
            if (!svf.length) {
               svf = $(`<input type="hidden" name="${name}" />`)
               formdom.append(svf)
            }
            svf.val(submit.val())
         }

         // Turn our form data into serialised object data for passing to object creation
         FormValidation.validate(formid, vmodel, onvalidate)
      })
   }

   static validate(formid, vmodel, callback) {
      let formdom = $(formid)
      // Turn our form data into serialised object data, for passing to model to validate
      let form;
      if (vmodel instanceof Validator) {
         // vmodel is already instantiated. We just need to update its data
         vmodel.data = formdom.serializeObject()
         form = vmodel
      } else // Base class - create new instantiated model
         form = new vmodel(formdom.serializeObject())
      form.validate((err, result) => {
         // Result is an object keyed by field, of error messages
         formdom.removeClass("was-validated is-valid is-invalid")
         formdom.find('.invalid-feedback').empty().hide()
         // Show validation messages for invalid fields

         if (result) {
            Object.keys(result).forEach(field => {
               let fielddom = formdom.find('[name="'+field+'"]')
               fielddom.removeClass('is-valid').addClass('is-invalid')
               // Find or create an associated "help-block" for the field
               let groupdom = fielddom.closest('.form-group')
               if (!groupdom.length) groupdom = fielddom.closest('.form-check')
               // let msgdom = fielddom.closest('div:not(.form-check-inline)').find('.invalid-feedback')
               let msgdom = groupdom.find('.invalid-feedback')
               let helpdom = groupdom.find('.help-text')
               if (!msgdom.length) {
                  msgdom = $('<div class="invalid-feedback"/>')
                  groupdom.append(msgdom)
               }
               // Show "data-error" attribute if defined, otherwise the message returned from validator library
               let msg = fielddom.data('error') || (result[field] && result[field].slice(-1).pop()) || 'Field validation failed'
               if (msgdom.is(':empty'))
                  msgdom.html(msg).show()
               else
                  msgdom.append('<br/>'+msg).show()
               // Hide default help when showing error message
               helpdom.hide()
            })
         }
         // Update field classes based on validation
         formdom.find('input,select').each(function() {
            let fielddom = $(this)
            let field = fielddom.attr('name')
            if (field) {
               if (!result || !result[field])
                  fielddom.addClass('is-valid').removeClass('is-invalid')
               else
                  fielddom.removeClass('is-valid').addClass('is-invalid')
            }
         })
         // Used to add 'was-validated', but unless Fields have proper :valid/:invalid (not Classes), it shows all fields Valid
         formdom.addClass("is-" + (result ? 'invalid' : 'valid'))
         callback(err, result)
      })
   }

   // Given a HTML form DOM, build a dynamic Validation object based on HTML validation
   static htmlFormValidation(formdom) {
      let schema = { }
      $.each(formdom.find(':input'), function(i, field) {
         field = $(field)
         let [name, required, required_when] = [field.attr('name'), field.attr('required') || field.data('required'), field.data('required-when')]
         if (!(name in schema))
            schema[name] = { type: 'string' }
         if (required)
            schema[name].required = true
         if (required_when)
            schema[name].required_when = required_when.split(/[,=]/)
         // console.log(field, name, required, required_when)
         // values[field.name] = field.value;
     })
   //   console.log(schema)
     let vmodel = new Validator()
     vmodel.schema = schema
     return vmodel
   }
}

module.exports = FormValidation
